import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { colors, fonts } from '../../theme';
export default {
  container: _objectSpread(_objectSpread({
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.1rem 2rem 0.7rem',
    minHeight: '3.6rem',
    minWidth: '14rem',
    paddingLeft: function paddingLeft(props) {
      return props.icon && !props.iconRight && '2rem';
    },
    paddingRight: function paddingRight(props) {
      return props.icon && props.iconRight && '2rem';
    },
    border: '1px solid',
    borderRadius: '3rem',
    lineHeight: '1.2',
    fontSize: '1.2rem'
  }, fonts.UniversRoman), {}, {
    textTransform: 'uppercase',
    textDecoration: 'none',
    letterSpacing: '0.05em',
    userSelect: 'none',
    cursor: 'pointer',
    transition: 'color .3s, border-color .3s, background-color .3s'
  }),
  // specific states
  containerDefault: {
    '&:hover': {
      backgroundColor: colors.lightGrey
    }
  },
  containerTransparent: {
    borderColor: 'transparent',
    '&:hover': {
      borderColor: 'transparent',
      textDecoration: 'underline'
    }
  },
  containerDisabled: {
    color: colors.midGrey,
    borderColor: colors.midGrey,
    backgroundColor: colors.pureWhite,
    cursor: 'not-allowed',
    '&:hover': {
      color: colors.midGrey,
      borderColor: colors.midGrey,
      backgroundColor: colors.pureWhite
    }
  },
  // icons
  icon: {
    position: 'relative',
    marginRight: function marginRight(props) {
      return props.label && !props.iconRight && '1.2rem';
    },
    marginLeft: function marginLeft(props) {
      return props.label && props.iconRight && '1.2rem';
    }
  },
  iconAsset: {},
  iconRight: {
    flexDirection: 'row-reverse !important',
    justifyContent: 'space-between'
  }
};